import { render, staticRenderFns } from "./NoticeChatTarget.vue?vue&type=template&id=6d96b4d0&scoped=true&"
import script from "./NoticeChatTarget.vue?vue&type=script&lang=ts&"
export * from "./NoticeChatTarget.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeChatTarget.vue?vue&type=style&index=0&id=6d96b4d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d96b4d0",
  null
  
)

export default component.exports